import React, { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { TimePickerModal } from 'react-native-paper-dates';
import { TextInput } from './TextInput';

type Props = {
  label: string;
  showLabel?: boolean;
  value?: Date;
  onChange: (date: Date) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  testID?: string;
};

export function TimeInput({
  label,
  showLabel = true,
  value,
  onChange,
  placeholder,
  disabled = false,
  error = false,
  testID,
}: Props) {
  const [showPicker, setShowPicker] = useState(false);

  const formatDisplayValue = (): string => {
    if (!value) return '';
    return value.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleConfirm = ({
    hours,
    minutes,
  }: {
    hours: number;
    minutes: number;
  }) => {
    const newDate = value ? new Date(value) : new Date();
    newDate.setHours(hours, minutes, 0, 0);
    onChange(newDate);
    setShowPicker(false);
  };

  const handlePress = () => {
    if (!disabled) {
      setShowPicker(true);
    }
  };

  return (
    <View style={styles.container}>
      <Pressable onPress={handlePress} disabled={disabled}>
        <TextInput
          label={label}
          showLabel={showLabel}
          value={formatDisplayValue()}
          placeholder={placeholder ?? 'Select time'}
          editable={false}
          pointerEvents="none"
          error={error}
          testID={testID}
          dense={true}
        />
      </Pressable>

      <TimePickerModal
        locale="en"
        visible={showPicker}
        onDismiss={() => setShowPicker(false)}
        onConfirm={handleConfirm}
        hours={value?.getHours() ?? 0}
        minutes={value?.getMinutes() ?? 0}
        label="Select time"
        defaultInputType="keyboard"
        animationType="fade"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});
